import i18n from "../../../i18n";

// QR customer languages are configured separately from portal languages.
// `dir` drives layout; `img`/`emoji` are for the step-1 language screen.
export const QR_LANGUAGES = [
  { code: "en", label: "English", short: "En", dir: "ltr", img: "/images/uk-flag.jpg" },
  { code: "ar", label: "العربية", short: "عربي", dir: "rtl", img: "/images/saudi-flag.jpg" },
  { code: "fr", label: "Français", short: "Fr", dir: "ltr", emoji: "🇫🇷" },
  { code: "es", label: "Español", short: "Es", dir: "ltr", emoji: "🇪🇸" },
];

const BY_CODE = QR_LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = lang;
  return acc;
}, {});

export const qrLangDirection = (code) => BY_CODE[code]?.dir || "ltr";

export const qrLangShort = (code) => BY_CODE[code]?.short || "En";

const changeQrLanguageIfNeeded = (code) => {
  const currentCode = (i18n.resolvedLanguage || i18n.language || "").split(
    "-",
  )[0];

  if (currentCode !== code) {
    i18n.changeLanguage(code);
  }
};

// The stored QR language code, or null if the customer hasn't chosen yet.
// Migrates the legacy "lang" values ("ltr"/"rtl") saved by older builds.
export const readStoredQrLocale = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const code = localStorage.getItem("qr_locale");
  if (code && BY_CODE[code]) {
    return code;
  }

  const legacyDirection = localStorage.getItem("lang");
  if (legacyDirection === "rtl") {
    return "ar";
  }
  if (legacyDirection === "ltr") {
    return "en";
  }

  return null;
};

// Apply a QR language everywhere: persist it, switch i18n, set layout direction.
// "lang" keeps holding the direction (existing layout code reads it); "qr_locale"
// holds the specific code so French/Spanish survive a reload.
export const applyQrLanguage = (code, setAppConfigWrapper) => {
  const direction = qrLangDirection(code);

  if (typeof window !== "undefined") {
    localStorage.setItem("lang", direction);
    localStorage.setItem("qr_locale", code);
  }

  changeQrLanguageIfNeeded(code);
  setAppConfigWrapper({ direction });

  return direction;
};

// Restore the stored QR language on page mount. Returns the resolved code.
export const restoreQrLanguage = (setAppConfigWrapper) => {
  const code = readStoredQrLocale() || "en";
  changeQrLanguageIfNeeded(code);
  setAppConfigWrapper({ direction: qrLangDirection(code) });
  return code;
};
